// export const redirectTo = 'conf-home';
export const redirectTo = 'configurator-home'; //OSP team
export const disableVAS = false;
